import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Page from '../../layout/containers/Page/Page';
import pageName from './page';

// Components
import PageHeader from './components/PageHeader';
import MaintenanceNotice from './components/MaintenanceNotice';
import DocumentSection from './components/DocumentSection';
import EmptyState from './components/EmptyState';

// Data
import documentsDataByMarket from './data/documentsData';

// Styles
import { Container, EmptyCard } from './AdminDocumentsPage.styles';

const AdminDocumentsPage = () => {
  const { t, i18n } = useTranslation();
  const [expandedSections, setExpandedSections] = useState({});

  const documentsData = documentsDataByMarket[i18n.language] || [];

  const toggleSection = (categoryId) => {
    setExpandedSections((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };

  const handleDownloadDocument = (file) => {
    window.open(file.url, '_blank');
  };

  return (
    <Page page={pageName}>
      <Container>
        <PageHeader
          title={t('documentManagement')}
          description={t('manageDocumentsDesc')}
        />

        <MaintenanceNotice message={t('adminDocumentsMaintenanceNotice')} />

        {documentsData.length === 0 ? (
          <EmptyCard>
            <EmptyState icon="mdi-folder-outline" message={t('noSectionsYet')} />
          </EmptyCard>
        ) : (
          documentsData.map((category) => (
            <DocumentSection
              key={category.id}
              category={category}
              isExpanded={expandedSections[category.id] || false}
              onToggle={() => toggleSection(category.id)}
              onDownload={handleDownloadDocument}
            />
          ))
        )}
      </Container>
    </Page>
  );
};

export default AdminDocumentsPage;
